export default __webpack_public_path__ + "static/media/pgmico(26).db98e3ba.png";